import { Component } from '@angular/core';
import { LogoComponent } from "../../../../shared/components/logo/logo.component";
import { Router } from '@angular/router';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-admin-topbar',
  standalone: true,
  imports: [LogoComponent, TranslocoPipe],
  templateUrl: './admin-topbar.component.html',
  styleUrl: './admin-topbar.component.css'
})
export class AdminTopbarComponent {
  constructor(private router: Router) { }

  goToDashboard() {
    this.router.navigate(["/dashboard"]);
  }
}
